import { StyleOptions } from "./interfaces";

declare type animationType = { targets: (Element | string)[], translateX: number, form:HTMLFormElement,isAnimate?:boolean };

export function cssStyle(
  form:HTMLFormElement,
  fieldSets: NodeListOf<HTMLFieldSetElement>,
  translateX: number,
  fieldsetLength: number,
  fieldsetMarginWidth: number,
  styleOptions?: StyleOptions,
) {
  try {
    const fieldSetParent = form.querySelector("[fieldset__parent]") as HTMLElement;
    const fieldsetContainer = fieldSetParent.querySelector("[fieldset__container]") as HTMLElement;
    const fieldsetWidth = Math.abs(translateX);
    const fieldsetContainerWidth =
      fieldsetLength * fieldsetWidth + fieldsetMarginWidth;
    const defaultFieldSetParentStyle = {
      height: "100%",
      overflow: "hidden",
      width: `${fieldsetWidth}px`,
    };
    const defaultFormStyle = {
      width: `${fieldsetWidth}px`,
      height: "100%",
      boxSizing: "border-box",
    };

    const defaultFieldsetContainerStyle = {
      width: `${fieldsetContainerWidth}px`,
      height: "100%",
      overflow: "hidden",
      display: "flex",
      justifyContent: "space-between",
    };

    const defaultFieldsetStyle = {
      width: `${fieldsetWidth}px`,
      transition: "margin-left 0.4s ease-in-out",
      backgroundColor: "#FFFFFF",
      justifyContent: "space-between",
      display: "flex",
      flexDirection: "column",
      padding: "30px",
      border: "none",
      boxShadow: "0 0 5px rgba(255, 255, 255, 0.7137254902)",
      borderRadius: "3px",
    };

    // Fusionnez les styles par défaut avec les styles personnalisés
    const formStyle = Object.assign({}, defaultFormStyle, styleOptions?.form);
    const fieldSetParentStyle = Object.assign({},
      defaultFieldSetParentStyle,
      styleOptions?.fieldsetParent
    );
    const fieldsetContainerStyle = Object.assign({},
      defaultFieldsetContainerStyle,
      styleOptions?.fieldsetContainer
    );
    const fieldsetStyle = Object.assign({},
      defaultFieldsetStyle,
      styleOptions?.fieldset
    );

    Object.assign(form.style, formStyle);
    Object.assign(fieldSetParent.style, fieldSetParentStyle);
    Object.assign(fieldsetContainer.style, fieldsetContainerStyle);
    fieldSets.forEach((fieldSet, index) => {
      Object.assign(fieldSet.style, fieldsetStyle);
      fieldSet.classList.add(`fieldset${index}`);
    });
    return {fieldSetParentStyle,fieldsetContainerStyle,formStyle,fieldsetStyle}
  } catch (error) {
    console.error(error);
  }
}

const lastTranslateXMap = new Map<Element, number>();
export function anime(options: animationType) {
    options.targets.forEach(target => {
        const element = typeof target === 'string' ? options.form.querySelector(target) : target;
        if (element) {
            const lastTranslateX = lastTranslateXMap.get(element) || 0;
            const translateX = options.translateX;
            const keyframes: Keyframe[] = [
                { transform: `translateX(${lastTranslateX}px)` },
                { transform: `translateX(${translateX}px)` }
            ];
            const _animateOptions: KeyframeAnimationOptions = {
                duration: 1000,
                fill: 'forwards', // L'animation reste appliquée à la fin
                easing: 'cubic-bezier(1, 0, 0, 1)' // Approximation de l'effet d'assouplissement easeInOutExpo
            };
            const _unanimateOptions: KeyframeAnimationOptions = {
              fill: 'forwards',
            };
            if (element.animate) {
                if(options.isAnimate != false)element.animate(keyframes, _animateOptions);
                else{element.animate(keyframes,_unanimateOptions)}
                lastTranslateXMap.set(element, translateX);
            }
        }
    });
}
